import { useMutation} from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { getOrdersPricelistOffersById } from "../../../../services/orders/pricelist-offers-get-by-id";
import { PricelistOffersGetByIdPayload} from "../../../../services/orders/pricelist-offers-get-by-id/types";
import SessionService from "../../../../services/session-service";
import { OfferView } from "../../offer-view";
import { mesageErrorDebugUnloggedClient, statusChandleData, statusChandleDataFinalOffer } from "../helpers/pre-selection-data";
import { getMessageOfErrorsDebugUnlogedClient, getNumberOfErrorsDebugUnlogedClient, OfferViewComponent, StatusChandleDataResponse } from "../helpers/types";
import { TokenAccessExpired } from "../../offer-view/components/view-variants/token-access-expired";
import { ordersPricelistMoq } from "../helpers/maq-data";
import { OfferHasBeenFinallyAccepted } from "../../offer-view/components/view-variants/offer-has-been-finally-accepted-or-no-offer-to-final-accept";
import { auth } from "../../../../redux/actions";
import { useAppDispatch } from "../../../../hooks/redux-hooks";
import { LoadingBackDrop } from "../../../../components/loader";

export const FinalOfferFromEmailClientUnlogged = () => {
    const { id, token24 } = useParams();
   
    const [preOrdersPricelist, setPreOrdersPricelist] = useState<PricelistOffersGetByIdPayload>();
    const [preSelectionData,setPreSelectionData]=useState<StatusChandleDataResponse>();
    const [errorMessage, setErrorMessage]=useState("");
    const [errorView,setErrorView]=useState(false);
    const dispatch = useAppDispatch();
    
    const getOrdersPricelistOffersByIdMutation = useMutation(getOrdersPricelistOffersById, {
        onSuccess: (res) => {
            setPreSelectionData(statusChandleDataFinalOffer(res.data?.payload));
            const newRes:PricelistOffersGetByIdPayload={
                id_zamowienie: res.data.payload.id_zamowienie,
                numer_zamowienia: res.data.payload.numer_zamowienia,
                data_zlozenia: res.data.payload.data_zlozenia,
                status_zamowienia: res.data.payload.status_zamowienia,
                opis_uslugi: res.data.payload.opis_uslugi,
                termin_rozpoczecia: res.data.payload.termin_rozpoczecia,
                termin_zakonczenia: res.data.payload.termin_zakonczenia,
                kraj: res.data.payload.kraj,
                wojewodztwo: res.data.payload.wojewodztwo,
                kod_pocztowy: res.data.payload.kod_pocztowy,
                miasto: res.data.payload.miasto,
                miejsce: res.data.payload.miejsce,
                skladowanie_plaskie: res.data.payload.skladowanie_plaskie,
                wysokie_skladowanie: res.data.payload.wysokie_skladowanie,
                polki: res.data.payload.polki,
                warunek_temperaturowy: res.data.payload.warunek_temperaturowy,
                rodzaj_towaru: res.data.payload.rodzaj_towaru,
                opis_towaru: res.data.payload.opis_towaru,
                specjalny_sprzet: res.data.payload.specjalny_sprzet,
                dodatkowe_uwagi: res.data.payload.dodatkowe_uwagi,
                oferty: statusChandleDataFinalOffer(res.data?.payload).data,
                uslugi_zamowione: {
                    cel_zamowienia: res.data.payload.uslugi_zamowione.cel_zamowienia,
                    uslugi_dodatkowe: res.data.payload.uslugi_zamowione.uslugi_dodatkowe,
                    ilosc_dodatkowych:res.data.payload.uslugi_zamowione.ilosc_dodatkowych,
                    uslugi_zamowione_id: res.data.payload.uslugi_zamowione.uslugi_zamowione_id,
                }
            };
            setPreOrdersPricelist(newRes);
            setErrorView(false);
        },
        onError: (err:any) => {
            setErrorMessage(mesageErrorDebugUnloggedClient(err.response.data.errors_debug[0]));
            setErrorView(true);
        },
    });

    useEffect(() => {

        SessionService.clearUserSession();
        SessionService.clearLoggedUserData();
        dispatch(auth.userLogout());

        SessionService.setTokenForUnlogedClient({
            token: token24?token24:null,
            });
         getOrdersPricelistOffersByIdMutation.mutate({
            id_zamowienie: id,
            token:  token24, 
          })
    }, []);

    if (getOrdersPricelistOffersByIdMutation.isLoading) {
        return <LoadingBackDrop loading={true} />;
      }
    return (
        <> 
        {errorView
            ? (<TokenAccessExpired error_debug={errorMessage}/>)
            :
            preSelectionData?.view===OfferViewComponent.finalOffertView
                ?<OfferView 
                    offer_id_from_email={id} 
                    data={preOrdersPricelist}
                    isFinalOffer={true}
                    token24={token24}
                    /> 
                : <OfferHasBeenFinallyAccepted/>
        }
       </>
    );
};